/**
 * Helpers for network scan target text (CIDR / single IP).
 */

/**
 * If the first token is a bare IPv4 (no "/"), return the same network as x.x.x.0/24.
 * @param {string} text
 * @returns {string|null}
 */
export function expandFirstIpv4ToSlash24(text) {
  const raw = (text || '').trim();
  if (!raw) return null;
  const line = raw.split(/[\s,]+/)[0];
  if (!line || line.includes('/')) return null;
  const parts = line.split('.');
  if (parts.length !== 4) return null;
  const n = parts.map((p) => parseInt(p, 10));
  if (n.some((x) => Number.isNaN(x) || x < 0 || x > 255)) return null;
  return `${n[0]}.${n[1]}.${n[2]}.0/24`;
}

/**
 * @param {string} text
 * @returns {boolean}
 */
export function isBareSingleIpv4(text) {
  return expandFirstIpv4ToSlash24(text) != null;
}
